// @flow
import type { ContractVehiclePlanVehicle, ContractVehicle } from './../types';
import CommonApi from './../commonApi';
const contractVehiclePlanVehicle = new CommonApi<
  ContractVehiclePlanVehicle,
  {},
  ContractVehicle
>('contractVehiclePlanVehicle', 'ТС для плана НТС');
export default contractVehiclePlanVehicle;
